import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Toggle from '../Toggle';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XP44Deck extends Component {
    constructor(props) {
        super(props);
        this.handleDeckChange = this.handleDeckChange.bind(this);
        this.handleTeakOnSideDecksChange = this.handleTeakOnSideDecksChange.bind(this);
        this.handleTeakOnCoachroofChange = this.handleTeakOnCoachroofChange.bind(this);
    }


    handleDeckChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Deck = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTeakOnSideDecksChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnSideDecks = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTeakOnCoachroofChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnCoachroof = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;


        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2780, height: 965 }} transform={
                [
                    0.071489, -0.001427, 0, -0.000032,
                    0.012064, 0.088505, 0, 0.000043,
                    0, 0, 1, 0,
                    207, 355, 0, 1
                ]}>
                <ConfiguratorImage boat="XP44" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        if (this.props.configuration.BathingPlatform.value === 1) {
            image = <ConfiguratorImage boat="XP44" configuration={this.props.configuration} options={imageOptions} />;
        }

        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>

                    <h1><Trans defaults='Deck & cockpit' /></h1>
                    <p><Trans defaults='Standard on the Xp 44 is genuine teak on cockpit floor and seats. Genuine teak is with black caulkings and optional is Flexiteek finish with grey stripes. Side decks antislip area come standard in light grey gelcoat finish.' /></p>

                    <RadioGroup label={this.props.t("Deck material:")} options={this.props.deckOptions} value={this.props.configuration.Deck} onChange={this.handleDeckChange} />

                    <h3><Trans defaults='Deck options:' /></h3>

                    <Toggle checked={this.props.configuration.TeakOnSideDecks.value === 2} onChange={this.handleTeakOnSideDecksChange}>
                        <Trans defaults='{{wood}} on side decks' values={{ 'wood': (this.props.configuration.Deck.value === 1) ? 'Teak' : 'Flexiteek' }} />
                    </Toggle>
                    <Toggle checked={this.props.configuration.TeakOnCoachroof.value === 2} onChange={this.handleTeakOnCoachroofChange}>
                        <Trans defaults='{{wood}} on coachroof' values={{ 'wood': (this.props.configuration.Deck.value === 1) ? 'Teak' : 'Flexiteek' }} />
                    </Toggle>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP44Deck);


// WEBPACK FOOTER //
// ./src/XP44/XP44Deck.js